import { useEffect, useState, createContext, FC } from 'react';
import {
  DefaultOldCockpitTiles,
  DefaultOldCockpitTilesForSpecialMode,
  TilesInterface
} from '../components/Grid/tiles';
import { SpecialTiles, Tiles } from '../Constants';
import { useTour } from '@reactour/tour';
import { autoFillSpecialTiles } from '../helpers/tilesHelper';

interface ITilesContext {
  mainTiles: TilesInterface[];
  setMainTiles: any;

  resetTiles: any;
  isInSpecialMode: boolean;
  isInFinancesMode: boolean;
}

export const TilesContext = createContext<ITilesContext>({} as ITilesContext);

interface ITilesHandler {
  isInSpecialMode: boolean;
  isInFinancesMode: boolean;
  setGlobalTiles?: (tiles: TilesInterface[]) => void;
}
export const TilesHandler: FC<ITilesHandler> = ({
  children,
  isInSpecialMode,
  isInFinancesMode,
  setGlobalTiles
}) => {
  const [mainTiles, setMainTiles] = useState<TilesInterface[]>(
    isInSpecialMode
      ? DefaultOldCockpitTilesForSpecialMode
      : DefaultOldCockpitTiles
  );

  const { isOpen: isTutorialModalOpen } = useTour();

  useEffect(() => {
    if (!isTutorialModalOpen) {
      const storedTiles = JSON.parse(
        localStorage.getItem(isInSpecialMode ? SpecialTiles : Tiles) as string
      );

      storedTiles
        ? setMainTiles(storedTiles)
        : setMainTiles(
            isInSpecialMode
              ? DefaultOldCockpitTilesForSpecialMode
              : DefaultOldCockpitTiles
          );
    }
  }, [isTutorialModalOpen]);

  const resetTiles = () => {
    setMainTiles(
      isInSpecialMode
        ? DefaultOldCockpitTilesForSpecialMode
        : DefaultOldCockpitTiles
    );
    localStorage.removeItem(Tiles);
    localStorage.removeItem(SpecialTiles);
    setGlobalTiles &&
      setGlobalTiles(
        isInSpecialMode
          ? DefaultOldCockpitTilesForSpecialMode
          : DefaultOldCockpitTiles
      );
  };

  useEffect(() => {
    setGlobalTiles && setGlobalTiles(mainTiles);

    const storedTiles = localStorage.getItem(
      isInSpecialMode ? SpecialTiles : Tiles
    );

    const tilesHaveChanged = storedTiles !== JSON.stringify(mainTiles);
    const isDefaultTiles =
      JSON.stringify(mainTiles) ===
      JSON.stringify(
        isInSpecialMode
          ? DefaultOldCockpitTilesForSpecialMode
          : DefaultOldCockpitTiles
      );

    if (!isDefaultTiles && tilesHaveChanged && !isTutorialModalOpen) {
      autoFillSpecialTiles(isInSpecialMode, mainTiles, setMainTiles);

      localStorage.setItem(
        isInSpecialMode ? SpecialTiles : Tiles,
        JSON.stringify(mainTiles)
      );
    }
  }, [mainTiles]);

  return (
    <TilesContext.Provider
      value={{
        mainTiles,
        setMainTiles,
        resetTiles,
        isInSpecialMode,
        isInFinancesMode
      }}
    >
      {children}
    </TilesContext.Provider>
  );
};
